import React from 'react';

export const BroadcastingIndicator = ({ amIBroadcaster }) => {
    return (
        <>
            <button className="video-footer-button" id="broadcasting-badge">
                <img src="/assets/icon-video-labels.svg" alt="broadcasting" />
            </button>
            <div className="video-footer-label">Broadcasting</div>
            <nav className="navbar video-footer-menu p-0">
                <ul className="navbar nav flex-column align-items-start p-0 video-dropdown-menu">
                    <li className="nav-item p-1 pe-2 m-0 ">
                        <div className="d-flex justify-content-between">
                            <a className="nav-link p-0" href="#" onClick={(e) => e.preventDefault()}>
                                <img
                                    src={amIBroadcaster ? "/assets/icon-video-check.svg" : "/assets/transparent.png"}
                                    className="d-inline-block me-2"
                                    width="16"
                                    alt="check"
                                />
                                {amIBroadcaster ? "You are the broadcaster" : "You are not the broadcaster"}
                            </a>
                        </div>
                    </li>
                    <li className="video-dropdown-menu-caret p-0 m-0 text-center"></li>
                </ul>
            </nav>
        </>
    );
};
